import { selectSelectedPartner, selectSelectedRange, selectSelectedStore } from "modules/customer/tools/product/productSlice";
import React from "react";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const selectedPartner = useAppSelector(selectSelectedPartner);
    const selectedRange = useAppSelector(selectSelectedRange);
    const selectedStore = useAppSelector(selectSelectedStore);
    return (
        <>
            Assess the fit of {selectedRange?.name} in the {selectedPartner?.name} {selectedStore?.name} store.
            Evaluate local customer demographics, traffic patterns, and competitive positioning to
            understand the product's potential in this location.

        </>
    );
};

export default Subtitle;
